import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
    selector: 'app-public',
    template: `
        <div class="flex h-screen w-screen">
            <div class="hidden lg:flex flex-col items-center justify-center flex-[0_0_38%] relative overflow-hidden">
                <div class="absolute inset-0 bg-[url('/assets/images/login/bg.jpg')] bg-center bg-cover"></div>
                <div
                    class="absolute inset-0 bg-gradient-to-br from-sidebar/90 via-sidebar/75 to-primary-900/80"></div>
                <div class="relative z-10 flex flex-col items-center gap-6 px-12">
                    <img class="w-44" src="assets/images/cyberobics-logo-white.svg" alt="Cyberobics" />
                    <p class="text-white/80 text-lg font-light tracking-wide">Classes Admin</p>
                </div>
            </div>
            <div class="flex-1 flex items-center justify-center bg-surface px-6">
                <div class="w-full max-w-[420px]">
                    <div class="lg:hidden flex justify-center mb-10">
                        <img class="w-32" src="assets/images/logo-sidenav.svg" alt="Cyberobics" />
                    </div>
                    <router-outlet />
                </div>
            </div>
        </div>
    `,
    imports: [RouterOutlet],
})
export class PublicComponent {}
